<template>
  <div
    :id="`msg-${message.messageId}`"
    class="Message"
    ref="Message_list"
    :class="{
      'quote-focus':
        this.$store.state.chat.quoteMessageFocused &&
        this.$store.state.chat.quoteMessageFocused == message.messageId,
      'msg-selectable': selectable && isCustomerTextMessage,
      'msg-selected': selectable && selected,
      'msg-highlighted': highlighted,
    }"
  >
    <div class="Message-Message-left" v-if="!message.isType">
      <span
        v-if="selectable && isCustomerTextMessage"
        class="msg-select-checkbox"
        @click.stop="toggleSelect"
      >
        <span v-if="selected" uk-icon="check"></span>
        <span v-else class="unchecked-circle"></span>
      </span>
      <p class="Message-Author">
        <strong>{{
          message.custNameNew == '' ? message.custName : message.custNameNew
        }}</strong>
      </p>
      <p class="Message-Content" v-bgImage="message.msg">
        <span class="reply reply-left" @click="reply">
          <span uk-icon="icon: reply;"></span> <span>&nbsp;Reply</span>
        </span>
        <span
          v-if="message.quotedMessageContent"
          class="quote-message"
          @click="scrollToQuote(message.quotedMessageId)"
        >
          <strong>ข้อความ&nbsp;:&nbsp;</strong>
          <span v-msgChat:html="message.quotedMessageContent"></span>
        </span>
        <span class="msg" v-msgChat:html="message.msg"></span>
      </p>
      <small v-time="message.time"></small>
    </div>
    <div class="Message-Message-right" v-else>
      <p class="Message-Author">
        <strong v-nameChat:html="message"></strong>
      </p>
      <p class="Message-Content" v-bgmsg="message">
        <span class="reply reply-right" @click="reply">
          <span uk-icon="icon: reply;"></span> <span>&nbsp;Reply</span>
        </span>
        <span
          v-if="message.quotedMessageContent"
          class="quote-message"
          @click="scrollToQuote(message.quotedMessageId)"
        >
          <strong
            >{{
              message.quotedMessageSender.replace('\{\{customer\}\}', 'ลูกค้า')
            }}&nbsp;:&nbsp;</strong
          >
          <span v-msgChat:html="message.quotedMessageContent"></span>
        </span>
        <span
          class="msg"
          v-if="!message.isUpload"
          v-msgChat:html="message.msg"
        ></span>
      </p>
      <small
        class="error-status"
        v-show="message.pushStatus === 'failed'"
      >
        <span class="retry-btn" @click="fnReSendMessage(message)" title="ลองส่งอีกครั้ง">
          <i class="fas fa-redo"></i> ลองใหม่
        </span>
        <span class="remove-btn" @click="fnRemoveMessage(message)" title="ลบข้อความ">
          <i class="fas fa-times"></i>
        </span>
        <span class="error-text">{{ message.pushError || 'การส่งข้อมูลผิดพลาด' }}</span>
      </small>
      <small class="pending-status" v-show="message.pushStatus === 'pending'">
        <i class="fas fa-spinner fa-spin"></i> กำลังส่ง...
      </small>
      <small v-time="message.time"></small>
    </div>
  </div>
</template>

<script>
import dateFormat from 'dateformat';
import { mapGetters } from 'vuex';
import { Menu, MenuItem } from 'element-ui';
import { convertChatHtml } from '../functions/format-string';

export default {
  props: ['data', 'selectable', 'selected', 'highlighted'],
  data() {
    return {
      showMenu: { left: false, right: false },
      menuPosition: { x: 0, y: 0 },
    };
  },
  computed: {
    message: function() {
      /*  if (this.data.resId.indexOf('"') > -1) { this.data.resId = replace(this.data.resId, /"/g, ''); } */
      return this.data;
    },
    isCustomerTextMessage: function() {
      // Only customer string messages are selectable for manual AI suggestion (exclude stickers)
      const isSticker = this.data.msg && this.data.msg.indexOf('stickershop') > -1;
      return (
        !this.data.isType &&
        this.data.sender !== 'R' &&
        this.data.type === 'string' &&
        !isSticker
      );
    },
    ...mapGetters('profile', ['profile']),
  },
  components: {
    [Menu.name]: Menu,
    [MenuItem.name]: MenuItem,
  },
  directives: {
    bgImage: {
      bind: function(el, binding) {
        if (binding.value) {
          if (binding.value.indexOf('img') > 0) {
            el.style.backgroundColor = 'unset';
          } else {
            el.style.backgroundColor = 'whitesmoke';
          }
        }
      },
      update: function(el, binding) {
        if (binding.value) {
          if (binding.value.indexOf('img') > 0) {
            el.style.backgroundColor = 'unset';
          } else {
            el.style.backgroundColor = 'whitesmoke';
          }
        }
      },
    },
    bgmsg: {
      bind: function(el, binding, vnode) {
        if (binding.value.custName == 'Mapper') {
          el.style.backgroundColor = '#ffa50061';
        } else if (binding.value.resId != vnode.context.profile.reservationId) {
          el.style.backgroundColor = 'rgba(255, 0, 151, 0.2)';
        } else {
          el.style.backgroundColor = '#00978b61';
        }
      },
      update: function(el, binding, vnode) {
        if (binding.value.custName == 'Mapper') {
          el.style.backgroundColor = '#ffa50061';
        } else if (binding.value.resId != vnode.context.profile.reservationId) {
          el.style.backgroundColor = 'rgba(255, 0, 151, 0.2)';
        } else {
          el.style.backgroundColor = '#00978b61';
        }
      },
    },
    time: {
      bind: function(el, binding) {
        var nowDate = dateFormat(new Date(), 'dd mmm yy');
        var dateBinding = dateFormat(new Date(binding.value), 'dd mmm yy');

        if (nowDate == dateBinding) {
          el.innerHTML = dateFormat(new Date(binding.value), 'HH:MM น.');
        } else {
          el.innerHTML = dateFormat(
            new Date(binding.value),
            'dd mmm yy | HH:MM น.',
          );
        }
      },
      update: function(el, binding) {
        var nowDate = dateFormat(new Date(), 'dd mmm yy');
        var dateBinding = dateFormat(new Date(binding.value), 'dd mmm yy');

        if (nowDate == dateBinding) {
          el.innerHTML = dateFormat(new Date(binding.value), 'HH:MM น.');
        } else {
          el.innerHTML = dateFormat(
            new Date(binding.value),
            'dd mmm yy | HH:MM น.',
          );
        }
      },
    },
    msgChat: {
      bind: function(el, binding, vnode) {
        // var msgCoustBinding = removeElements(binding.value);
        // el.innerHTML = fnCheckTypeMessage(
        //   vnode.context.data.type,
        //   msgCoustBinding,
        // );
        el.innerHTML = convertChatHtml(
          vnode.context.data.type,
          binding.value,
          localStorage.getItem('sitetpx'),
        );
      },
      update: function(el, binding, vnode) {
        // var msgCoustBinding = removeElements(binding.value);
        // el.innerHTML = fnCheckTypeMessage(
        //   vnode.context.data.type,
        //   msgCoustBinding,
        // );
        el.innerHTML = convertChatHtml(vnode.context.data.type, binding.value);
      },
    },
    nameChat: {
      bind: function(el, binding, vnode) {
        el.innerHTML =
          parseInt(binding.value.resId) !==
          parseInt(vnode.context.profile.reservationId)
            ? binding.value.resNickname
            : binding.value.custName;
      },
      update: function(el, binding, vnode) {},
    },
  },
  mounted() {
    if (!this.data.quoteToken) {
      return;
    }
    const msgContent = document.querySelector(
      `#msg-${this.data.messageId} .Message-Content`,
    );
    const replyBox = msgContent.querySelector('.reply');
    let leaving = false;
    msgContent.addEventListener('mouseenter', () => {
      leaving = false;
      replyBox.classList.add('reply-active');
      console.log('mouse enter', replyBox);
    });
    msgContent.addEventListener('mouseleave', () => {
      leaving = true;
      setTimeout(function() {
        if (!leaving) {
          return;
        }
        leaving = false;
        replyBox.classList.remove('reply-active');
      }, 350);
    });
  },
  onUnmounted() {
    //
    const msgContent = document.querySelector(
      `#msg-${this.data.messageId} .Message-Content`,
    );
    if (msgContent) {
      msgContent.removeEventListener('mouseenter');
      msgContent.removeEventListener('mouseleave');
    }
  },
  methods: {
    fnReSendMessage(data) {
      this.$emit('fnReSendMessage', data);
    },
    fnRemoveMessage(data) {
      this.$emit('fnRemoveMessage', data);
    },
    scrollToQuote(messageId) {
      console.log('quote', messageId);
      this.$store.dispatch('chat/toQuotedMessage', messageId);
      // this.$store.dispatch('chat/loadMoreMessage', {
      //     custId: this.firstMessage.custId,
      //     custName: this.firstMessage.custName,
      //     time: this.firstMessage.time,
      //     type: 'scroll',
      //   });
    },
    handleContextMenu(position) {
      console.log('context', position);
      this.showMenu[position] = true;
    },
    handleCloseMenu(position) {
      this.showMenu[position] = false;
    },
    handleReply() {
      console.log('Reply option clicked');
      // Add your reply logic here
    },
    reply() {
      this.$store.dispatch('chat/setReply', this.data);
    },
    toggleSelect() {
      this.$emit('toggleSelect', this.data);
    },
  },
};
// function removeElements(text) {
//   if (typeof text === 'object') {
//     return text;
//   }
//   var div = document.createElement('div');
//   div.innerHTML = text;
//   return div.textContent || div.innerText || '';
// }
</script>

<style>
#ChatBox .Message {
  background: white;
  overflow: hidden;
  padding: 10px;
  transition: background-color 1s ease;
}
#ChatBox .Message.quote-focus {
  background: rgb(255, 234, 198);
}

#ChatBox .Message p {
  margin: 0;
}

#ChatBox .Message-Content img.ui-path-img {
  width: 70%;
  height: 70%;
}

#ChatBox .Message .Message-Message-right p.Message-Author {
  color: #000;
  margin-bottom: 5px;
  font-size: 1.3em;
  text-align: right;
}

#ChatBox .Message .Message-Message-right p.Message-Content {
  max-width: 600px;
  border-radius: 18px;
  padding: 12px;
  float: right;
  background: #00978b61;
  text-align: left;
  font-size: 1.49em;
}

#ChatBox .Message .Message-Message-right small {
  float: right;
  clear: both;
  font-size: 1.1em;
  color: #a8a8a8;
}
#ChatBox .Message .Message-Message-right small.red {
  float: right;
  clear: both;
  cursor: pointer;
  margin-top: 5px;
}

#ChatBox .Message .Message-Message-right small.error-status {
  float: right;
  clear: both;
  margin-top: 8px;
  color: #dc3545;
  background-color: #fff5f5;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 1em;
  display: flex;
  align-items: center;
  gap: 12px;
}

#ChatBox .Message .Message-Message-right small.error-status .retry-btn {
  cursor: pointer;
  color: #007bff;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 1em;
  font-weight: 500;
}

#ChatBox .Message .Message-Message-right small.error-status .retry-btn:hover {
  background-color: #e7f1ff;
}

#ChatBox .Message .Message-Message-right small.error-status .remove-btn {
  cursor: pointer;
  color: #6c757d;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 1em;
}

#ChatBox .Message .Message-Message-right small.error-status .remove-btn:hover {
  background-color: #f8d7da;
  color: #dc3545;
}

#ChatBox .Message .Message-Message-right small.error-status .error-text {
  color: #dc3545;
  font-size: 0.95em;
}

#ChatBox .Message .Message-Message-right small.pending-status {
  float: right;
  clear: both;
  margin-top: 5px;
  color: #6c757d;
  font-size: 0.9em;
}

#ChatBox .Message .Message-Message-left p.Message-Author {
  color: #000;
  margin-bottom: 5px;
  font-size: 1.3em;
  text-align: left;
}

#ChatBox .Message .Message-Message-left p.Message-Content {
  max-width: 500px;
  border-radius: 18px;
  padding: 12px;
  float: left;
  background: whitesmoke;
  text-align: left;
  font-size: 1.4em;
  color: #000;
  position: relative;
}

#ChatBox .Message .Message-Message-left small {
  float: left;
  clear: both;
  font-size: 1.1em;
  color: #a8a8a8;
}

#ChatBox .Message-Content span.msg {
  word-break: break-all;
  word-wrap: break-word;
  overflow: hidden;
  display: inline-block;
  letter-spacing: 0px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  white-space: pre-line;
}
#ChatBox .Message-Content span.quote-message {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: start;
  padding: 4px;
  margin-bottom: 18px;
  background-color: #ffffff;
  border-radius: 12px;
  border: 1px solid #aaaaaa;
  cursor: pointer;
  word-break: break-word;
}
#ChatBox .Message-Content span.quote-message strong {
  white-space: nowrap;
}
.Message-Content {
  position: relative;
}
.Message-Content > .reply {
  position: absolute;
  right: 0px;
  padding-left: 12px;
  transform: translateX(100%);
  display: none;
  cursor: pointer;
  white-space: nowrap;
  top: 0px;
  background-color: #ffedc6;
  font-weight: bold;
}
.Message-Content > .reply-left {
  right: -4px;
}
.Message-Content > .reply-right {
  left: -4px;
  padding-right: 12px;
  transform: translateX(-100%);
}
.Message-Content > .reply.reply-active {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 104px;
  border-radius: 8px;
  border: 1px solid #ef9c55;
}
/* Message selection styles */
#ChatBox .Message.msg-selectable {
  cursor: pointer;
}
#ChatBox .Message.msg-selectable .Message-Message-left {
  position: relative;
  padding-left: 30px;
}
#ChatBox .Message.msg-selected {
  background-color: #e3f2fd;
}
.msg-select-checkbox {
  position: absolute;
  left: 4px;
  top: 50%;
  transform: translateY(-50%);
  color: #1976d2;
  cursor: pointer;
  z-index: 1;
}
.msg-select-checkbox .unchecked-circle {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid #bbb;
  border-radius: 50%;
}
/* Message highlight on suggestion hover */
#ChatBox .Message.msg-highlighted {
  background-color: #fff3e0;
  box-shadow: inset 0 0 0 2px #ff9800;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
}
</style>



// WEBPACK FOOTER //
// src/components/ChatMessage.vue